import React, {useState, useEffect} from 'react';
import '../App.css';
import {toast} from 'react-toastify';
import {Link, useLocation, useParams} from 'react-router-dom';
import {Select} from 'antd';
import ExpenseListProjectDetail from '../components/ExpenseListProjectDetail';
import api from '../Interceptor';
import {getRoute} from '../api/routes';
import GetCurrencySymbol from '../components/GetCurrencySymbol';
import ExpenseGraph from '../components/ExpenseGraph';
import AddExpense from './AddExpense';
import useModal from '../hooks/useModal';
import {fetchAllExpenses} from '../features/expenses/expenseActions';
import {useDispatch, useSelector} from 'react-redux';
import {calculateDuration} from '../utils/calculateDuration';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faRefresh,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';
import {durationOptions} from '../utils/filters';
import {fetchFilteredExpensesApi} from '../api/services/allExpenses';
const {Option} = Select;

const ProjectDetail = () => {
  const user = useSelector((state) => state.auth.user);
  const {expenseByProjectId} = useSelector((state) => state.expense);
  const location = useLocation();
  const dispatch = useDispatch();
  const {projectId: paramProjectId} = useParams();
  const projectId = location.state?.projectId || paramProjectId;
  const {projectname: paramProjectName} = useParams();
  const projectName = location.state?.projectName || paramProjectName;
  const [selectedDuration, setSelectedDuration] = useState('all');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split('T')[0]
  );
  const [loading, setLoading] = useState(false);
  const [milestoneList, setMilestoneList] = useState([]);
  const [selectedMilestone, setSelectedMilestone] = useState('All');
  const [projectCurrency, setProjectCurrency] = useState(null);
  const [totals, setTotals] = useState({
    income: 0,
    expense: 0,
    netProfit: 0,
  });
  const fetchProjectDetails = async () => {
    try {
      const response = await api.get(
        `${getRoute(
          'users',
          user.userRole.name,
          'projects',
          false,
          false,
          ''
        )}?id=${projectId}`
      );
      setProjectCurrency(response.data.currency);
    } catch (error) {
      toast.error('Error fetching project details', error);
    }
  };
  useEffect(() => {
    if (projectId) {
      fetchProjectDetails();
      fetchMilestones(projectId);
    }
  }, [projectId, selectedMilestone]);
  const {
    income: totalIncome,
    expense: totalExpense,
    netProfit,
  } = totals;
  const {isOpen, toggleModal} = useModal();
  const fetchMilestones = async () => {
    try {
      let url = `${getRoute(
        'users',
        user.userRole.name,
        'projects',
        false,
        false,
        'milestone'
      )}`;
      url += `?projectId=${projectId}`;
      const response = await api.get(url);
      setMilestoneList(response.data);
    } catch (error) {
      toast.error('Error fetching milestones', error);
    }
  };

  useEffect(() => {
    const {newStartDate, newEndDate} = calculateDuration('all');

    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }, []);

  useEffect(() => {
    if (projectId) {
      fetchMilestones(projectId);
      // fetchExpenses(projectId, selectedMilestone);
    }
  }, [projectId, selectedMilestone]);

  useEffect(() => {
    if (projectId && selectedMilestone && startDate && endDate) {
      // fetchExpenses(projectId, selectedMilestone, startDate, endDate);
    }
  }, [projectId, selectedMilestone, startDate, endDate]);
  const handleDurationChange = (value) => {
    setSelectedDuration(value);
    const {newStartDate, newEndDate} = calculateDuration(value);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };
  const handleMilestoneChange = (value) => {
    setSelectedMilestone(value);
  };

  const handleSuccess = () => {
    if (user?.userRole?.name && projectId) {
      dispatch(
        fetchAllExpenses({
          userRole: user.userRole.name,
          projectId,
          currencyView: 'ProjectCurrency',
        })
      );
    }
  };
  useEffect(() => {
    if (user?.userRole?.name && projectId) {
      dispatch(
        fetchAllExpenses({
          userRole: user.userRole.name,
          projectId,
          currencyView: 'ProjectCurrency',
        })
      );
    }
  }, [projectId, user, dispatch]);
  useEffect(() => {
    const fetchProjectTotals = async () => {
      if (!user?.userRole?.name || !projectId) return;

      const data = await fetchFilteredExpensesApi({
        userRole: user.userRole.name,
        selectedProject: projectId,
        selectedMilestone: 'All',
        currencyView: 'ProjectCurrency',
        includeTotals: true,
      });
      setTotals({
        income: Number(data?.totals?.income) || 0,
        expense: Number(data?.totals?.expense) || 0,
        netProfit: Number(data?.totals?.netProfit) || 0,
      });
    };

    fetchProjectTotals();
  }, [projectId, user, expenseByProjectId]);
  const handleRefresh = () => {
    setSelectedDuration('all');
    setSelectedMilestone('All');
    const {newStartDate, newEndDate} = calculateDuration('all');
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };
  if (loading)
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  return (
    <>
      {isOpen ? (
        <AddExpense
          onSuccess={handleSuccess}
          onCancel={toggleModal}
          isModalOpen={isOpen}
          projectId={projectId}
        />
      ) : null}
      <div className="min-h-screen  flex flex-col p-3 gap-2 overflow-hidden font-customFont">
        {/* Project Name and Dates */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          <div style={{fontFamily: 'Noto Serif, sans-serif'}}>
            <h1 className="font-bold text-lg md:text-xl flex items-center gap-2 capitalize">
              {projectName}
            </h1>
          </div>
          <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto mt-3 md:mt-0">
            {/* <Link to="/addExpense"> */}
            <button
              className="bg-themeGradient text-white hover:bg-themeGradientHover px-3 py-1 rounded-md flex items-center justify-center w-full"
              onClick={toggleModal}
            >
              <i className="fa-solid fa-plus text-lg"></i>
              <span className="ms-2">New Transaction</span>
            </button>
            {/* </Link> */}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {/* Total Net Income Card */}{' '}
          <div className="group relative overflow-hidden border border-blue-200 bg-gradient-to-br from-blue-50 via-white to-blue-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col sm:col-span-2 lg:col-span-1">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-md">
                  <FontAwesomeIcon
                    icon={faWallet}
                    className="text-white text-md"
                  />
                </div>
                <p className="text-blue-700 text-sm font-semibold uppercase tracking-wide">
                  Net Income
                </p>
              </div>
            </div>
            <p className="text-blue-900 text-3xl font-bold mt-1 relative z-10">
              <GetCurrencySymbol currencyId={projectCurrency?._id} />{' '}
              <span>{Math.floor(netProfit).toLocaleString()}</span>
              <span className="text-blue-600 text-xl">
                .{netProfit.toFixed(2).split('.')[1]}
              </span>
            </p>
            <p className="text-blue-600 text-xs mt-1 font-medium">
              Total profit after expenses
            </p>
          </div>
          {/* Total Income Card */}{' '}
          <div className="group relative overflow-hidden border border-green-200 bg-gradient-to-br from-green-50 via-white to-green-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col ">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center shadow-md">
                  <FontAwesomeIcon
                    icon={faArrowTrendUp}
                    className="text-white text-md"
                  />
                </div>
                <p className="text-green-700 text-sm font-semibold uppercase tracking-wide">
                  Income
                </p>
              </div>
            </div>
            <p className="text-green-900 text-3xl font-bold mt-2 relative z-10">
              <GetCurrencySymbol currencyId={projectCurrency?._id} />{' '}
              <span>{Math.floor(totalIncome).toLocaleString()}</span>
              <span className="text-green-600 text-xl">
                .{totalIncome.toFixed(2).split('.')[1]}
              </span>
            </p>
            <p className="text-green-600 text-xs mt-1 font-medium">
              Total earnings received
            </p>
          </div>
          {/* Total Expense Card */}{' '}
          <div className="group relative overflow-hidden border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100 shadow-lg transition-all duration-300 rounded-2xl p-4 pb-3 flex flex-col">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center shadow-md">
                  <FontAwesomeIcon
                    icon={faArrowTrendDown}
                    className="text-white text-md"
                  />
                </div>
                <p className="text-red-700 text-sm font-semibold uppercase tracking-wide">
                  Expense
                </p>
              </div>
            </div>
            <p className="text-red-900 text-3xl font-bold mt-2 relative z-10">
              <GetCurrencySymbol currencyId={projectCurrency?._id} />{' '}
              <span>{Math.floor(totalExpense).toLocaleString()}</span>
              <span className="text-red-600 text-xl">
                .{totalExpense.toFixed(2).split('.')[1]}
              </span>
            </p>
            <p className="text-red-600 text-xs mt-1 font-medium">
              Total amount spent
            </p>
          </div>
        </div>
        <div className="w-full rounded-2xl bg-white border border-[#D5D7DA] shadow-lg p-3">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <p className="font-semibold font-customFont">Overview</p>

            <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto font-customFont">
              <Select
                defaultValue="All"
                id="filterMilestone"
                value={selectedMilestone}
                onChange={(value) => handleMilestoneChange(value)}
                className={`ring-1 rounded-md w-full sm:w-40 ${
                  selectedMilestone || selectedMilestone === 'All'
                    ? ''
                    : 'ring-blue-400'
                }`}
              >
                <Option value="All">All Milestones</Option>
                {milestoneList.map((mile) => (
                  <Option key={mile._id} value={mile._id}>
                    {mile.name}
                  </Option>
                ))}
              </Select>
              {/* Duration Filter Dropdown */}
              <Select
                value={selectedDuration}
                onChange={handleDurationChange}
                className={`w-full sm:w-40 ${
                  selectedDuration
                    ? 'ring-1 ring-blue-400  sm:col-span-2 lg:col-span-1 rounded-md'
                    : ''
                }`}
              >
                {durationOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
              <button
                onClick={handleRefresh}
                className="text-black border border-[#DCE3E3] px-2 py-2 rounded-md flex items-center justify-center w-full md:w-auto"
              >
                <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
              </button>
            </div>
          </div>

          {/* Expense Graph - Added height */}
          <div className="mt-4 h-[300px] md:h-[350px] lg:h-[400px]">
            <ExpenseGraph
              selectedProject={projectId}
              selectedMilestone={selectedMilestone}
              selectedDuration={selectedDuration}
              startDate={startDate}
              endDate={endDate}
              projectCurrency={projectCurrency?._id}
            />
          </div>
        </div>
        <div>
          <ExpenseListProjectDetail
            expenseByProjectId={expenseByProjectId}
            selectedMilestone={selectedMilestone}
            selectedProject={projectId}
            onExpenseChange={handleSuccess}
          />
        </div>
      </div>
    </>
  );
};

export default ProjectDetail;
